<script>
import Datepicker from 'vuejs-datepicker';
import PostcodeFinder from '../PostcodeFinder';
import CouponFinder from '../CouponFinder';
import Errors from '../../helpers/Errors';
import * as moment from 'moment';


export default {
        props: ['old', 'errorMessages'],

        components: {
            Datepicker,
            PostcodeFinder,
            CouponFinder
        },

        data() {
            return {
                fields: {
                    address: {},
                    tenancy_start: '',
                    tenancy_end: '',
                    tenancy_move_in: '',
                    tenancy_start_is_move_in: true,
                    tenancy_has_started: '',
                    housemates: '',
                    bill_payers: '',
                    tenant_type: '',
                    university_name: '',
                    university_team: '',
                    letting_agent: {
                        name: ''
                    },
                    coupon: '',
                    name_of_agent: ''
                },
                errors: new Errors(JSON.parse(this.errorMessages)),
                format: 'dd/MM/yy',
                tenant_types: {
                    STUDENT: 'student',
                    PROFESSIONAL: 'professional-tenant'
                }
            }
        },

        methods: {
            tenantToggle() {
                if (this.fields.tenant_type === this.tenant_types.STUDENT) {
                    this.fields.tenant_type = this.tenant_types.PROFESSIONAL;
                } else {
                    this.fields.tenant_type = this.tenant_types.STUDENT;
                }
            },
            disabledTenancyEndDates() {
                let start_date = new Date(this?.fields?.tenancy_start ? this.fields.tenancy_start : Date.now());
                return { to: start_date };
            },
            afterThreeMonths() {
                let start_date = new Date(this?.fields?.tenancy_start ? this.fields.tenancy_start : Date.now());
                return new Date(start_date.setMonth(new Date(start_date).getMonth() + 3));
            }
        },

        created() {
            if (this.old) {
                try {
                    // Fill form with old data
                    _.merge(this.fields, JSON.parse(this.old));

                    // Set values at integers
                    this.fields.housemates = parseInt(this.fields.housemates);
                    this.fields.bill_payers = parseInt(this.fields.bill_payers);

                    // Convert to date strings to Javascript Date objects
                    let start_date = moment(this.fields.tenancy_start, 'DD/MM/YY');
                    let end_date = moment(this.fields.tenancy_end, 'DD/MM/YY');
                    let move_in_date = moment(this.fields.tenancy_move_in, 'DD/MM/YY');

                    // Assign date objects to fields
                    this.fields.tenancy_start = start_date.isValid() ? start_date.toString() : '';
                    this.fields.tenancy_end = end_date.isValid() ? end_date.toString() : '';
                    this.fields.tenancy_move_in = move_in_date.isValid() ? move_in_date.toString() : '';

                } catch (e) {
                    // No old data..
                }
            }
        }
    }
</script>
